<template>
    <Navbar :rightBtn="true"  :title="'立项查询结果'"></Navbar>
    <div class="content-bg">
        <!-- <img class="img" src="@/assets/images/bg/bg_6@2x.png" /> -->
        <div class="title">全国政策申报立项数据库</div>
        <div class="sub-title">查询百万条企业立项信息</div>
        <div class="header">
            <div class="match-container-search" @click.stop="() => { }">
                <input type="text" placeholder="请输入搜索关键词" v-model="company" @focus="handleInput" />
                <div class="btn" @click="onSearch">
                    <img src="@/assets/images/vector@2x.png" alt="">
                </div>
            </div>
        </div>
    </div>
     <div class="empty" v-show="emptyShow">
            <div class="empty-txt">{{emptyTxt}}</div> 
            <div class="empty-img-box">
                <img src="@/assets/images/empty_1@2x.png"/>
            </div>
    </div>
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" v-if="!emptyShow" @load="getData" immediate-check="false">
        <div class="policy-file-item" v-for="record in list" :key="record">
            <div class="content">
            <div><span class="label">政策名称：</span>{{record._PolicyName}}</div>
            <div><span class="label">申报单位：</span>{{record._CompanyName}}</div>
            <div><span class="label">项目类型：</span>{{record._ProjectType}}</div>
            <div><span class="label">所属口径：</span>{{record._Source}}</div>
            <div><span class="label">立项时间：</span>{{record._ApprovalDate}}</div>
            <div v-if="record._ApprovalAmount"><span class="label">立项金额：</span><span class="amount">{{record._ApprovalAmount}}万元</span></div>
            </div>
        </div>
    </van-list>
</template>
<script>
import axios from 'axios'
import Navbar from '@/components/Navbar'
import { lxcxLists } from '@/api/home'
export default {

    data() {

        return {
            list: [],
            loading: false,
            finished: false,
            listTotal:0,
            company:'',
            emptyShow: true,
            emptyTxt: '信息再多，一查便知。',
            page:{
                count: 0,
                size: 50,
                total: 0
            },
        }
    },
    components: { Navbar, },
    computed: {},

    mounted() {
        this.company = this.$route.query.name
     this.onSearch()
    },
    watch: {},
    methods: {
        async onSearch() {
            var that = this
            if(!this.company){
                this.$toast({message:'请输入企业名称'})
                return false
            }
            that.list = []
            that.page.count = 0
            that.getData()
            // this.loading = true
            // this.$toast.loading({
            //     forbidClick: true
            // })
            // axios.get('/app/lxcx/lists',{
            //     params:{
            //         company:this.company
            //     }
            // }).then((re)=>{
            //     let res = re.data
            //     if(res.status != 0){
            //         that.$toast.clear()
            //         this.list = []
            //         this.listTotal = 0
            //         this.emptyShow = true
            //         this.emptyTxt = '暂无数据'
            //         return false
            //     }
            //     if(res.result.result == 'fail'){
            //         this.$toast({message:res.result.msg})
            //         return false
            //     }
            //     that.$toast.clear()
            //     if(res.result.tablerecord){
            //         this.list = res.result.tablerecord || []
            //         this.listTotal = Number(res.result.recordcount)
            //         // this.finished = this.list.length >= this.listTotal && this.listTotal != 0 ? true : false
            //         this.finished = true 
            //         this.emptyShow = !res.result.tablerecord.length ?true : false
            //     }else{
            //         this.list = []
            //         this.listTotal = 0
            //         this.emptyShow = true
            //         this.emptyTxt = '暂无数据'
            //     }
            // }).finally(()=>{
            //     this.loading = false
            // })
        },
        async getData() {
             var that = this
            this.page.count += 1
            this.loading = true
            this.$toast.loading({
                forbidClick: true
            })
            try {
                let params = {
                    company: this.company,
                    page: this.page.count,
                    pageSize: this.page.size,
                }
                let res = await lxcxLists(params)
                if(res.result.result == 'fail'){
                    this.$toast({message:res.result.msg})
                    return false
                }
                that.$toast.clear()
                if(res.result.tablerecord){
                    this.list = this.list.concat(res.result.tablerecord) || []
                    this.page.total = Number(res.result.recordcount) || 0
                    this.listTotal = Number(res.result.recordcount) || 0
                    this.finished = this.list.length >= this.listTotal && this.listTotal != 0 ? true : false
                    this.emptyShow = !this.listTotal ?true : false
                }else{
                    this.list = []
                    this.listTotal = 0
                    this.page.total = 0
                    this.emptyShow = true
                    this.emptyTxt = '暂无数据'
                }
            } catch {
                
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content-bg{
    background: url('../../assets/images/bg/bg_6@2x.png');
    background-size: 100% 100%;
}
.box {
    width: 100%;
    margin: 20px 0;
    text-align: center;
    font-size: 16px;

    .company {
        font-size: 20px;
        margin-bottom: 5px;
    }

    
}
.content{
    padding:15px;
    font-size: 14px;
    line-height: 20px;
    .label{
        font-weight: 600;
        color: #6aa6e2;
    }
    .amount {
        color: #d01414;
        font-weight: 600;
    }
}

.title {
  font-size: 24px;
  font-weight: bold;
  color: #FFF;
  position: relative;
  margin: 50px 10px 20px;
  text-align: center;
}

.sub-title {
  font-size: 12px;
  color: #FFF;
  line-height: 21px;
  position: relative;
  margin: 10px;
  text-align: center;
}

.header {
  margin: 35px auto 20px;
  // background: linear-gradient(219deg, #FFFFFF 0%, #1293ED 100%);
  box-shadow: 0px 4px 12px 1px rgba(193, 210, 223, 0.25);
  border-radius: 10px;
  padding: 20px 12px;
  position: relative;
  border: 1px solid #fff;
  background: #fff;;
}

.match-container-search {
  height: 42px;
  // margin: 0 12px;
  border: 1px solid #189FF2;
  // background: #d7f0ff;
  border-radius: 26px;
  display: flex;
  position: relative;
  display: flex;
  flex-direction: row;
  background: #fff;
  box-shadow: 0px 4px 4px 1px rgba(96, 178, 236, 0.25);

  input {
    flex: 1;
    height: 36px;
    border-top-left-radius: 26px;
    border-bottom-left-radius: 26px;
    border: 0;
    // border-right: 2px solid #ededed;
    border-right: 2px solid #fff;
    box-sizing: border-box;
    padding: 0 8px 0 30px;
    font-size: 12px;
    // background: #d7f0ff;
    background: #fff;
    margin: 4px 0;

    &::placeholder {
      color: #808080;
    }
  }

  .btn {
    width: 60px;
    height: 36px;
    background: #0F96E9;
    border-radius: 26px;
    border: 1px solid rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto 3px auto 7px;

    img {
      width: 27px;
      background-size: contain;
    }
  }

  .detail {
    width: 100%;
    position: absolute;
    top: 48px;
    left: 0px;
    z-index: 999;
  }
}
.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 16px;
    margin-top: 50px;
    .empty-img-box {
         width: 240px;
        height: 137px;
        img {
            width: 100%;
            height: 100%;
            background-size: contain;
        }
    }
     .empty-txt {
            margin-top:16px;
            font-size: 12px;
            font-weight: 400;
            color: #7CC1EF;
            margin-bottom: 30px;
        }
}
</style>
